<template>
  <!-- Модальное окно -->
  <div
    class="modal fade"
    id="tv-selector"
    tabindex="-1"
    @click.self="closeModal"
    ref="tv-selector"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content shadow-lg">
        <!-- Заголовок -->
        <div class="modal-header bg-primary text-white">
          <h5 class="modal-title">
            <i class="bi bi-tv me-2"></i>{{ $t("tv-selector.lable") }}
          </h5>
          <button
            type="button"
            class="btn-close btn-close-white"
            data-bs-dismiss="modal"
            @click="closeModal"
          ></button>
        </div>

        <!-- Тело модального окна -->
        <div class="modal-body">
          <div class="row">
            <div v-for="tv in televisions" :key="tv._id" class="col-md-4 mb-4">
              <div
                class="card tv-card h-100 border-0 shadow-sm bg-info"
                :class="{
                  selected: selectedTvId === tv._id,
                  'border-primary': selectedTvId === tv._id,
                }"
                @click="selectTv(tv)"
              >
                <div class="card-body text-center p-4 text-primary">
                  <div class="tv-icon mb-3">
                    <i class="bi bi-tv" style="font-size: 3rem"></i>
                  </div>
                  <h5 class="card-title fw-bold mb-2">
                    {{ tv.tv_name }}
                  </h5>

                  <div class="mt-2">
                    <small>
                      {{ $t(`change.room.${$hotel}`, 1) }}:
                      {{ tv.room_number }}
                    </small>
                  </div>
                </div>
                <div
                  class="card-footer bg-transparent border-0 text-center"
                  v-if="selectedTvId === tv._id"
                >
                  <span class="badge bg-success fs-6">
                    <i class="bi bi-check-circle me-1"></i>
                    {{ $t("common.select.selection.selected") }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Футер модального окна -->
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" @click="closeModal">
            <i class="bi bi-x-circle me-1"></i>
            {{ $t("common.cancel.cancel") }}
          </button>
          <button
            type="button"
            class="btn btn-success"
            :disabled="!selectedTvId"
            @click="confirmSelection"
          >
            <i class="bi bi-check-circle me-1"></i>
            {{ $t("common.select.selection.confirmSelection") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { prop, Vue } from "vue-class-component";
import { Modal } from "bootstrap";

interface Television {
  _id: string;
  room_number: string;
  tv_name: string;
}

class Props {
  isModalOpen = prop<boolean>({ default: false });
  televisions = prop<Array<Television>>({ required: true, default: [] });
}

class TvSelector extends Vue.with(Props) {
  // Reactive properties
  selectedTvId = "";
  selectionLog = "Начните выбор телевизора...\n";
  lastSelectedTv: Television | null = null;
  selectionCount = 0;

  private offcanvasInstance: Modal | null = null;
  $refs!: { "tv-selector": HTMLElement };

  get offcanvasElement(): HTMLDivElement {
    return this.$refs["tv-selector"] as HTMLDivElement;
  }

  mounted(): void {
    this.$nextTick(() => this.initializeOffcanvas());
  }

  beforeUnmount() {
    this.offcanvasInstance?.dispose();
  }

  // Methods
  private initializeOffcanvas() {
    if (!this.offcanvasElement) return;
    this.offcanvasInstance = new Modal(this.offcanvasElement);
  }

  public openOffcanvas(): void {
    console.log(this.offcanvasInstance);

    this.offcanvasInstance?.show();
  }

  public closeOffcanvas(): void {
    this.offcanvasInstance?.hide();
  }

  closeModal(): void {
    this.$emit("isModalOpen", false);
    this.selectedTvId = "";
    document.body.style.overflow = "auto";

    const modal = this.$refs["tv-selector"];
    const bootstrapModal = Modal.getInstance(modal);
    if (bootstrapModal) bootstrapModal.hide();
  }

  selectTv(tv: Television): void {
    this.selectedTvId = tv._id;
    this.lastSelectedTv = tv;
    this.selectionCount++;

    // Update screen log
    const timestamp = new Date().toLocaleTimeString();
    this.selectionLog += `[${timestamp}] 📺 Выбран: ${tv.tv_name} (ID: ${tv._id})\n`;
  }

  confirmSelection(): void {
    if (!this.selectedTvId) return;
    this.$emit("selectedTv", this.selectedTvId);
    this.closeModal();
  }
}
export default TvSelector;
</script>

<style lang="scss" scoped>
@import "../../../assets/sass/variables.scss";
.modal-content {
  border-radius: 20px;
  border: none;
}

.tv-card {
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid transparent;
  border-color: $info !important;
  background: linear-gradient(135deg, #ede7f6 0%, $info 100%);
  color: $primary;
}

.tv-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px $primary !important;
  border-color: $dark !important;
}
</style>
